import { forwardRef } from 'react';

import DateTimeInputInline from 'components/Inputs/inline/DateTimeInput';

import { withCellWrapper } from '../helpers';

const _DateCreatedCell = forwardRef(
  ({ value, field, shouldFocusNext, entityId, objectId, adornments }, ref) => {
    return (
      <DateTimeInputInline
        ref={ref}
        field={field}
        entityId={entityId}
        objectId={objectId}
        readOnly
        value={value}
        shouldFocusNext={shouldFocusNext}
        showDateTooltip
        adornments={adornments}
      />
    );
  }
);

export const DateCreatedCell = withCellWrapper(_DateCreatedCell);
